// extracted by mini-css-extract-plugin
export default {"container":"EducationIntro_container__njR3Z","contents":"EducationIntro_contents__RPPNZ","space":"EducationIntro_space__EH1zv"};